<template>
    <div id="accessStoreInfo" ref="accessStoreInfo">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart no-print"  style="width: 19%;">
            <p class="headerT">退料信息</p>
            <el-form ref="returnForm" :model="returnForm" id="test"  label-width="80px" :label-position="labelPosition">
                <el-form-item label="退料编号:">
                    <el-input :disabled="true" :value="returnForm.code"></el-input>
                    <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.materialCode,$event)"></i>
                </el-form-item>
                <el-form-item label="退料类型:">
                    <el-input :disabled="true" v-model="returnForm.returnTypeName"></el-input>
                </el-form-item>
                <!-- <el-form-item label="残值类型:" v-if="returnForm.returnType == '2'">
                    <el-input :disabled="true" v-model="returnForm.returnMaterialType" ></el-input>
                </el-form-item> -->
                <el-form-item label="操作人:">
                    <el-input :disabled="true" v-model="returnForm.createUser" ></el-input>
                </el-form-item>
                <el-form-item label="提交时间:">
                    <el-input :disabled="true" v-model="returnForm.createTime" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr"  style="width: 79%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    id="table"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :summary-method="getSummaries"
                    show-summary
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        type="index"
                        width="50"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inventoryCode"
                        label="序列号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="orderNo"
                        width="100"
                        label="关联订单号">
                        <template slot-scope="scope">
                            {{scope.row.orderNo}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="maintainPrice"
                        width="150"
                        label="维修金额(元)">
                        <template slot-scope="scope">
                            {{scope.row.maintainPrice}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="returnForm.returnType == 2"
                        align="center"
                        prop="residualValue"
                        width="150"
                        label="残值单价(元)">
                        <template slot-scope="scope">
                            {{scope.row.residualValue}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="pickTime"
                        width="150"
                        label="领用时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="belonger"
                        width="100"
                        label="退料人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        v-if="returnForm.returnType !== '2'"
                        label="是否自留">
                        <template slot-scope="scope" v-if="returnForm.returnType !== '2'">
                            <span v-if="scope.row.isRetenRetain == 0">否</span>
                            <span v-else-if="scope.row.isRetenRetain == 1">自留</span>
                            <span v-else>保留</span>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
        </el-col>
    </div>
</template>
<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        returnMaterialDetails,
        returnMaterialDetailsList
    } from "../../api/api";
    export default {
        name: 'accessStoreInfo',
        components: {},
        data () {
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                orderId:'',
                labelPosition:'left',
                returnForm:{},
                returnData: []
            }
        },
        created:function(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.orderId) {
                var userOrderId = sessionStorage.getItem('saveOrderId');
                this.orderId = JSON.parse(userOrderId);
            }else{
                let orderId = this.$route.query.orderId
                this.orderId = orderId
            }
            this.getReturnMaterialDetails()     //获取出入库信息
            this.getReturnMaterialDetailsList() //获取物料信息
        },
        methods: {
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getReturnMaterialDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getReturnMaterialDetailsList()
            },
            //获取订单详情
            getReturnMaterialDetails() {
                let para={
                    id: this.orderId
                }
                returnMaterialDetails(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnForm = res.data.results;
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime)
                        sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.id));

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                  this.$Message.error(error.message);
                })
            },
            //获取订单详情分页
            getReturnMaterialDetailsList() {
                let para={
                    pId: this.orderId,
                }
                returnMaterialDetailsList(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnData = res.data.results.list;
                        this.returnData.forEach((item,index)=>{
                            item.pickTime = this.filters.formatDate(item.pickTime)
                        })
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //复制内容
            handleCopy(text, event) {
                clip(text, event)
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/returnMaterManage'
                })
            },
            refresh() {
                this.getReturnMaterialDetailsList()
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 7 || index === 1 || index === 4) {
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            }
            
        },
        computed: {
        },
        watch: {},
    }
</script>


<style type="text/css" lang="scss" scoped>
    #accessStoreInfo{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
            .childSpan{padding-left: 20px;margin-bottom: 5px;}
            .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
            .childSpan span.orderId{color: #3399FF;}
            .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
                background-color: #1abc9c;margin: 0px 15px 0px -5px;}
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
    .dialog-content{
        width:900px;
        margin:0 auto;
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }
                
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// returnMaterInfo.vue?5bcb973c